import React from 'react';
import MyOrdersRightArrow from '../../molecules/my_orders_right_arrow/my_orders_right_arrow.js';
import Title from '../../atoms/title/title.js';
import Icon from '../../atoms/icon/icon.js';
import { liveChat } from './img/live_chat.js';
import { videoCall } from './img/video_call.js';
import { voiceCall } from './img/voice_call.js';
import { clock } from './img/clock.js';

const MyOrdersOrderCell = ({ type = "live-chat", orderSubject, orderCreatedAt, orderDescription, reviewType = null, labels = [] }) => {
    const renderLabel = () => (React.createElement("div", { className: 'mbw-my-orders-order-cell-labels-holder-container' }, labels.map((label, index) => (React.createElement("div", { className: 'mbw-my-orders-order-cell-label-container', key: index, "data-testid": "mbw-my-orders-order-cell-label-container" }, label)))));
    const getOrderIcon = (icon) => (React.createElement(Icon, { className: `mbw-my-orders-order-cell-${type}-icon`, dataTestId: "mbw-my-orders-order-cell-icon" }, icon));
    const renderOrderIcon = () => {
        let orderIcon = null;
        switch (type) {
            case "live-chat":
                orderIcon = getOrderIcon(liveChat);
                break;
            case "video-call":
                orderIcon = getOrderIcon(videoCall);
                break;
            case "voice-call":
                orderIcon = getOrderIcon(voiceCall);
                break;
            default:
                orderIcon = null;
        }
        return orderIcon;
    };
    const renderOrderSubject = () => (React.createElement("div", { className: "mbw-my-orders-order-cell-subject-container", "data-testid": "mbw-my-orders-order-cell-subject-container" },
        React.createElement(Title, { fontStyle: 'heading-h5', bold: true }, orderSubject)));
    const renderOrderTitle = () => (React.createElement("div", { className: "mbw-my-orders-order-cell-title-container" },
        renderOrderIcon(),
        renderOrderSubject()));
    const renderOrderCreatedAt = () => (React.createElement("div", { className: "mbw-my-orders-order-cell-order-created-at-container", "data-testid": "mbw-my-orders-order-cell-order-created-at-container" },
        React.createElement(Title, { fontStyle: 'content-default' }, orderCreatedAt)));
    const renderOrderDescription = () => (React.createElement("div", { className: "mbw-my-orders-order-cell-order-description-container", "data-testid": "mbw-my-orders-order-cell-order-description-container" },
        React.createElement(Icon, { className: "mbw-my-orders-order-cell-order-description-icon" }, clock),
        React.createElement(Title, { fontStyle: 'content-default' }, orderDescription)));
    const renderMyOrdersAdvisorCell = () => (React.createElement("div", { className: "mbw-my-orders-order-cell-container" },
        React.createElement("div", { className: "mbw-my-orders-order-cell-content-container" },
            React.createElement("div", { className: "mbw-my-orders-order-cell-order-title-labels-container" },
                renderOrderTitle(),
                renderLabel()),
            React.createElement("div", { className: "mbw-my-orders-order-cell-order-data-container" },
                renderOrderCreatedAt(),
                renderOrderDescription())),
        React.createElement("div", { className: 'mbw-my-orders-order-cell-right-arrow-container' },
            React.createElement(MyOrdersRightArrow, { withReview: !!reviewType, reviewType: reviewType }))));
    return renderMyOrdersAdvisorCell();
};

export { MyOrdersOrderCell as default };
//# sourceMappingURL=my_orders_order_cell.js.map
